import {Scene} from 'phaser';
import {getReadableColor} from "src/game/GameHelper";

export class GAHPreloader extends Scene {
  constructor() {
    super('GAHPreloader');
  }

  init() {
    const gameWidth = this.game.config.width;
    const gameHeight = this.game.config.height;
    const readableColor = getReadableColor(this.game.options.themeColor);

    const dynamicColor = Phaser.Display.Color.HexStringToColor(this.game.options.themeColor).color; // Convert hex string to Phaser color
    const graphics = this.add.graphics();
    graphics.fillStyle(dynamicColor, 0.7);
    graphics.fillRect(0, 0, gameWidth, gameHeight);

    const barWidth = gameWidth - 200;
    const innerBarWidth = barWidth - 16;
    this.add.rectangle(gameWidth / 2, gameHeight - 200, barWidth, 40).setStrokeStyle(4, Phaser.Display.Color.HexStringToColor(readableColor).color);
    const bar = this.add.rectangle((gameWidth - innerBarWidth) / 2, gameHeight - 200, 4, 30, Phaser.Display.Color.HexStringToColor(readableColor).color);
    this.load.on('progress', (progress) => {
      bar.width = 4 + (innerBarWidth * progress);
    });
  }

  preload() {
    let bgAudioUrl = null;
    let ballTopImageUrl = null;
    let adImageUrl = null;
    const options = this.game.options;
    if (options) {
      if (options.images && options.images.length > 0) {
        options.images.forEach((item) => {
          if (item.url && (item.url.startsWith('file:') || item.url.startsWith('blob:') || item.url.startsWith('http:') || item.url.startsWith('https:'))) {
            if (item.number === 0) {
              ballTopImageUrl = item.url;
            } else if (item.number === 1) {
              adImageUrl = item.url;
            }
          }
        });
      }
      if (options.audios && options.audios.length > 0) {
        options.audios.forEach((item) => {
          if (item.url && (item.url.startsWith('file:') || item.url.startsWith('blob:') || item.url.startsWith('http:') || item.url.startsWith('https:'))) {
            if (item.number === 0) {
              bgAudioUrl = item.url;
            }
          }
        });
      }
    }

    this.load.setPath('media/gameArcHunter');

    this.load.image('ballTop', ballTopImageUrl || 'ballTop.png');
    this.load.image('rawAdImage1', adImageUrl || 'adImage.png');

    this.load.image('rawBall', 'ball.png');
    this.load.image('handPointer', 'handPointer.png');

    if (!options.simulation) {
      this.load.audio('audio_bg', bgAudioUrl || 'audios/audio_bg.m4a');
      this.load.audio('audio_fire', 'audios/audio_fire.mp3');
      this.load.audio('audio_hit', 'audios/audio_hit.mp3');
      this.load.audio('audio_game_end', 'audios/audio_game_end.wav');
      this.load.audio('audio_game_win', 'audios/audio_game_win.mp3');
    }
  }

  create() {
    const space = 9;
    const ballSize = 112;
    const ballTopSize = ballSize - 2*space;
    const ballCenterX = ballSize/2;
    const ballCenterY = ballSize/2;
    const renderTextureBall = this.make.renderTexture({x: ballCenterX, y: ballCenterY, width: ballSize, height: ballSize}, false);
    const imageBall = this.add.image(ballCenterX, ballCenterY, 'rawBall')
      .setDisplaySize(ballSize, ballSize)
      .setVisible(false);
    const maskShapeBallTop = this.make.graphics({}, false)
      .fillCircle(ballCenterX, ballCenterY, ballTopSize/2);
    const imageBallTop = this.add.image(ballCenterX, ballCenterY, 'ballTop')
      .setDisplaySize(ballTopSize, ballTopSize)
      .setVisible(false);
    imageBallTop.setMask(maskShapeBallTop.createGeometryMask());
    renderTextureBall.draw(imageBall, ballCenterX, ballCenterY, 1);
    renderTextureBall.draw(imageBallTop, ballCenterX, ballCenterY, 1);
    renderTextureBall.saveTexture('ball');
    imageBall.destroy(true);
    maskShapeBallTop.destroy(true);
    imageBallTop.destroy(true);
    renderTextureBall.destroy(true);

    const bannerSize = 225;
    const bannerCenterX = bannerSize/2;
    const bannerCenterY = bannerSize/2;
    const renderTextureBanner = this.make.renderTexture({x: bannerCenterX, y: bannerCenterY, width: bannerSize, height: bannerSize}, false);
    const imageBanner = this.add.image(bannerCenterX, bannerCenterY, 'rawAdImage1')
      .setDisplaySize(bannerSize, bannerSize)
      .setVisible(false);
    const maskShapeBannerTop = this.make.graphics({}, false)
      .fillCircle(bannerCenterX, bannerCenterY, bannerSize/2);
    imageBanner.setMask(maskShapeBannerTop.createGeometryMask());
    renderTextureBanner.draw(imageBanner, bannerCenterX, bannerCenterY, 1);
    renderTextureBanner.saveTexture('adImage1');
    imageBanner.destroy(true);
    maskShapeBannerTop.destroy(true);
    renderTextureBanner.destroy(true);

    this.scene.start('GAHGame');
  }
}
